import Header from '../components/layout/header/Header';
import Hero from '../components/homepage/Hero';
import About from '../components/homepage/About';
import Footer from '../components/layout/footer/Footer';

function HomePage() {
    return (
        <>
            <Header />
            <Hero />
            <About />
            <Footer />
        </>
    );
}

export default HomePage;
